module.exports = __webpack_public_path__ + "img/Cranberry Concentrate.3bbc3ac1.jpg";